<template>
  <div class="w-full flex flex-col gap-2">
    <ul
      role="list"
      class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-3 4xl:grid-cols-4 5xl:grid-cols-5"
      v-if="myVideos.length > 0"
    >
      <V4MyVideosCard
        v-for="video in myVideos"
        :key="video.id"
        :video="video"
      />
    </ul>

    <V4LoadingMyVideos
      v-if="loadingMyVideos && myVideos.length === 0"
      class="mt-4"
    />

    <EmptyData
      v-if="!loadingMyVideos && myVideos.length === 0"
      description="No videos uploaded yet."
    />

    <div
      class="flex justify-center items-center py-5"
      v-if="hasMore && myVideos.length > 0"
    >
      <ElButton
        v-if="!loadingMyVideos"
        @click="handleClickLoadMore"
        class="!bg-untitled-gray-800 !border-untitled-gray-800 hover:!bg-untitled-gray-900"
        type="primary"
      >
        Load More
      </ElButton>
      <p v-else class="text-sm text-untitled-gray-500">Loading more videos...</p>
    </div>
  </div>
</template>

<script setup>
import { useMyVideosStore } from "@/stores/my-videos/my-videos.store";
import { storeToRefs } from "pinia";
import { ElButton } from "element-plus";
import EmptyData from "@/components/utilities/EmptyData.vue";
import { defineOptions } from "vue";
import V4MyVideosCard from "./V4MyVideosCard.vue";
import V4LoadingMyVideos from "../V4LoadingMyVideos.vue";

defineOptions({
  inheritAttrs: false,
});

const myVideosStore = useMyVideosStore();
const { myVideos, loadingMyVideos, hasMore } = storeToRefs(myVideosStore);

const handleClickLoadMore = async () => {
  await myVideosStore.loadMoreMyVideos();
};
</script>

<style lang="scss" scoped></style>
